<template>
  <div class="content-payment-item">
    <custom-dialog width="550px" :title="model.title" :visible="visible" v-on="$listeners" appendToBody>
      <div class="dialog-body">
        <el-form @submit.native.prevent>
          <div class="form-label">
            <!-- <el-form-item label="" prop="paymentType"> -->
            <el-radio-group v-model="form.paymentType" :disabled="model.type === 'edit'">
              <el-radio label="1">{{ i18n.page_content_PartyB_pays_to_PartyA_representative }}</el-radio>
              <el-radio label="2" :disabled="contractInfo.partyAId === contractInfo.hqId">{{ i18n.page_content_PartyA_representative_pays_factory }}</el-radio>
              <el-radio label="3" :disabled="contractInfo.partyAId === contractInfo.afterServiceId">{{ i18n.page_content_PartyA_representative_pays_afterSales }}</el-radio>
            </el-radio-group>
            <!-- </el-form-item> -->
          </div>
        </el-form>
        <div class="payment-form">
          <div class="form-line">
            <div class="form-item" v-if="form.paymentType === '1'">
              <el-form :model="partAReceive" ref="partAReceive" label-position="top">
                <div class="payment-form-box">
                  <div class="line">
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_beneficiary" prop="consigneeOrgName">
                          <el-input v-model="partAReceive.consigneeOrgName" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_receiving_account" prop="consigneeAccount" :rules="partAReceive.isPrepayment === '1' ? rules.consigneeAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${partAReceive.consigneeOrgId}${partAConsigneeFlag}`"
                                v-model="partAReceive.consigneeAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: partAReceive.consigneeOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onConsigneeDepositNumber(arguments[0], partAReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(partAReceive.consigneeOrgId, 'partAConsigneeFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_class">
                          <custom-select v-model="partAReceive.paymentClass" code="payment_class" :disabled="true"></custom-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_receiving_account_bank" prop="consigneeBank">
                          <el-input v-model="partAReceive.consigneeBank" disabled style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_payment_account" prop="payerAccount" :rules="partAReceive.isPrepayment === '1' ? rules.payerAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${partAReceive.payerOrgId}${partAPayerFlag}`"
                                v-model="partAReceive.payerAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: partAReceive.payerOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onPayerDepositNumber(arguments[0], partAReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(partAReceive.payerOrgId, 'partAPayerFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_account_bank" prop="payerBank">
                          <el-input v-model="partAReceive.payerBank" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_amount" prop="totalAmount">
                          <el-input v-model="partAReceive.totalAmount" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_date" prop="tradeTime" :rules="partAReceive.isPrepayment === '1' ? rules.tradeTime : []">\
                          <custom-date-picker
                            v-model="partAReceive.tradeTime"
                            type="datetime"
                            align="right"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            :picker-options="afterToday"
                            style="width: 100%"
                            :placeholder="i18n.com_please_select"
                          ></custom-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_summary" prop="buyerTradeRemark" :rules="rules.buyerTradeRemark">
                          <el-input v-model="partAReceive.buyerTradeRemark" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_upload_payment_voucher" prop="partACertificate" :rules="partAReceive.isPrepayment === '1' ? rules.attachList : []">
                          <t-upload
                            style="width: 100%"
                            v-model="partAReceive.attachList"
                            :bizId="partAReceive.tradeId"
                            bizType="certificate"
                            type="file"
                            :limit="1"
                            @effect="checkImg(partAReceive, 'partACertificate')"
                          ></t-upload>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="form-item" v-else-if="form.paymentType === '2'">
              <el-form :model="hqReceive" ref="hqReceive" label-position="top">
                <div class="payment-form-box">
                  <div class="line">
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_beneficiary" prop="consigneeOrgName">
                          <el-input v-model="hqReceive.consigneeOrgName" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_receiving_account" prop="consigneeAccount" :rules="hqReceive.isPrepayment === '1' ? rules.consigneeAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${hqReceive.consigneeOrgId}${hqConsigneeFlag}`"
                                v-model="hqReceive.consigneeAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: hqReceive.consigneeOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onConsigneeDepositNumber(arguments[0], hqReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(hqReceive.consigneeOrgId, 'hqConsigneeFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_class">
                          <custom-select v-model="hqReceive.paymentClass" code="payment_class" :disabled="true"></custom-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_receiving_account_bank" prop="consigneeBank">
                          <el-input v-model="hqReceive.consigneeBank" disabled style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_payment_account" prop="payerAccount" :rules="hqReceive.isPrepayment === '1' ? rules.payerAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${hqReceive.payerOrgId}${hqPayerFlag}`"
                                v-model="hqReceive.payerAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: hqReceive.payerOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onPayerDepositNumber(arguments[0], hqReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(hqReceive.payerOrgId, 'hqPayerFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_account_bank" prop="payerBank">
                          <el-input v-model="hqReceive.payerBank" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_amount" prop="totalAmount">
                          <el-input v-model="hqReceive.totalAmount" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_date" prop="tradeTime" :rules="hqReceive.isPrepayment === '1' ? rules.tradeTime : []">
                          <custom-date-picker
                            v-model="hqReceive.tradeTime"
                            type="datetime"
                            align="right"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            default-time="00:00:00"
                            :picker-options="afterToday"
                            style="width: 100%"
                          ></custom-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_summary" prop="buyerTradeRemark" :rules="rules.buyerTradeRemark">
                          <el-input v-model="hqReceive.buyerTradeRemark" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_upload_payment_voucher" prop="hqCertificate" :rules="hqReceive.isPrepayment === '1' ? rules.attachList : []">
                          <t-upload
                            style="width: 100%"
                            v-model="hqReceive.attachList"
                            :bizId="hqReceive.tradeId"
                            bizType="certificate"
                            type="file"
                            :limit="1"
                            @effect="checkImg(hqReceive, 'hqCertificate')"
                          ></t-upload>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="form-item" v-else>
              <el-form :model="serviceReceive" ref="serviceReceive" label-position="top">
                <div class="payment-form-box">
                  <div class="line">
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_beneficiary" prop="consigneeOrgName">
                          <el-input v-model="serviceReceive.consigneeOrgName" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_receiving_account" prop="consigneeAccount" :rules="serviceReceive.isPrepayment === '1' ? rules.consigneeAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${serviceReceive.consigneeOrgId}${serviceConsigneeFlag}`"
                                v-model="serviceReceive.consigneeAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: serviceReceive.consigneeOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onConsigneeDepositNumber(arguments[0], serviceReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(serviceReceive.consigneeOrgId, 'serviceConsigneeFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_class">
                          <custom-select v-model="serviceReceive.paymentClass" code="payment_class" :disabled="true"></custom-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_receiving_account_bank" prop="consigneeBank">
                          <el-input v-model="serviceReceive.consigneeBank" disabled style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-row :gutter="16">
                          <el-col :span="18">
                            <el-form-item :label="i18n.label_payment_account" prop="payerAccount" :rules="serviceReceive.isPrepayment === '1' ? rules.payerAccount : []">
                              <custom-select
                                url="crmPartnerBankcardAvailableList"
                                :listener="`${serviceReceive.payerOrgId}${servicePayerFlag}`"
                                v-model="serviceReceive.payerAccount"
                                :props="{
                                  label: 'depositNumber',
                                  value: 'depositNumber',
                                }"
                                :params="{ bizId: serviceReceive.payerOrgId }"
                                :placeholder="i18n.com_please_select"
                                @change="onPayerDepositNumber(arguments[0], serviceReceive)"
                                width="100%"
                              ></custom-select>
                              <!--  -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="">
                              <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                              <el-button style="width: 100%" @click="addBankCard(serviceReceive.payerOrgId, 'servicePayerFlag')">{{ i18n.com_add_to }}</el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_account_bank" prop="payerBank">
                          <el-input v-model="serviceReceive.payerBank" style="width: 100%" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_amount" prop="totalAmount">
                          <el-input v-model="serviceReceive.totalAmount" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_date" prop="tradeTime" :rules="serviceReceive.isPrepayment === '1' ? rules.tradeTime : []">
                          <custom-date-picker
                            v-model="serviceReceive.tradeTime"
                            type="datetime"
                            align="right"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            default-time="00:00:00"
                            :picker-options="afterToday"
                            style="width: 100%"
                          ></custom-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_payment_summary" prop="buyerTradeRemark" :rules="rules.buyerTradeRemark">
                          <el-input v-model="serviceReceive.buyerTradeRemark" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="24">
                      <el-col :span="24">
                        <el-form-item :label="i18n.label_upload_payment_voucher" prop="serviceCertificate" :rules="serviceReceive.isPrepayment === '1' ? rules.attachList : []">
                          <t-upload
                            style="width: 100%"
                            v-model="serviceReceive.attachList"
                            :bizId="serviceReceive.tradeId"
                            bizType="certificate"
                            type="file"
                            :limit="1"
                            @effect="checkImg(serviceReceive, 'serviceCertificate')"
                          ></t-upload>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">{{ i18n.com_cancel }}</el-button>
        <el-button size="small" type="primary" @click="savePaymentItem">{{ i18n.com_confirm }}</el-button>
      </div>
    </custom-dialog>
    <!--添加银行卡-->
    <bankcard-address-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="refreshBankcardList"></bankcard-address-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import bankcardAddressDialog from '@/pages/crm/components/bankCardDialog.vue';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  components: { tUpload, bankcardAddressDialog },
  mixins: [dialogMixins, languageInjectMixins],
  props: {
    contractId: [Number, String],
    contractClass: [Number, String],
    operateFlag: [Number, String],

    firstTotal: [Number, String], // 首期乙方应付合计
    hqProfitTotal: [Number, String], // 首期甲方应付总部合计
    serviceProfitTotal: [Number, String], // 首期甲方应付售后合计
  },
  inject: ['getContractInfo'],
  computed: {
    rules() {
      return {
        isPrepayment: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qxzsfyfsq'),
        }, // 是否已付首期
        //
        consigneeAccount: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qxzskzh'),
        },
        payerAccount: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qxzfkzh'),
        }, // 付款日期
        tradeTime: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qxzfkrq'),
        }, //
        buyerTradeRemark: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qtxzy'),
        }, //
        attachList: {
          required: true,
          message: this.$t('crm_contract_paymentItem_dialog.qscfkpz'),
        }, // 上传付款凭证
      };
    },
    contractInfo() {
      return this.getContractInfo();
    },
  },
  watch: {
    contractInfo: function () {
      this.setContractInfo();
    },
    firstTotal: function () {
      // 乙方给甲方代表 首付款金额
      this.partAReceive.totalAmount = this.firstTotal;
    },
    hqProfitTotal: function () {
      // 甲方给总部 押金总额+总部应收首期租金
      this.hqReceive.totalAmount = this.hqProfitTotal;
    },
    serviceProfitTotal: function () {
      // 甲方给售后 售后应收金额
      this.serviceReceive.totalAmount = this.serviceProfitTotal;
    },
  },

  data() {
    return {
      // 服务中心
      form: {
        bizClass: '', // 合同类型
        bizId: '', // 合同id
        operateFlag: '', // 操作标识符
        paymentType: '1', // 付款类型
      },
      // 乙方是否已付款给甲方代表
      partAReceive: {
        consigneeOrgId: '', // 收款方组织id
        consigneeOrgName: '', // 收款方组织名称
        attachList: [], // 支付凭证
        partACertificate: '', // 上传表示
        consigneeAccount: '', // 收款方账号
        consigneeBank: '', // 收款方账号开户银行
        isPrepayment: '1', // 总部收到首付款，0-否，1-是
        payerAccount: '', // 付款方账号
        payerBank: '', // 付款方账号开户银行
        payerOrgId: '', // 付款方组织id
        payerOrgName: '', // 付款方组织名称
        totalAmount: '', // 支付金额
        buyerTradeRemark: '', // 摘要
        tradeTime: '', // 支付日期
        paymentClass: '1', // 交易方式
        tradeId: '', // 交易记录ID，编辑时必填
        type: '1', // 付款类型：1-乙方给甲方 2-甲方给总部 3-甲方给售后
      },
      // 甲方代表是否已付款给总部
      hqReceive: {
        attachList: [], // 支付凭证
        hqCertificate: '', // 上传表示
        consigneeAccount: '', // 收款方账号
        consigneeBank: '', // 收款方账号开户银行
        consigneeOrgId: '', // 收款方组织id
        consigneeOrgName: '', // 收款方组织名称
        isPrepayment: '1', // 总部收到首付款，0-否，1-是
        payerAccount: '', // 付款方账号
        payerBank: '', // 付款方账号开户银行
        payerOrgId: '', // 付款方组织id
        payerOrgName: '', // 付款方组织名称
        totalAmount: '', // 支付金额
        buyerTradeRemark: '', // 摘要
        tradeTime: '', // 支付日期
        paymentClass: '1', // 交易方式
        tradeId: '', // 交易记录ID，编辑时必填
        type: '2', // 付款类型：1-乙方给甲方 2-甲方给总部 3-甲方给售后
      },
      // 甲方代表是否已付款给售后
      serviceReceive: {
        attachList: [], // 支付凭证
        serviceCertificate: '', // 上传表示
        consigneeAccount: '', // 收款方账号
        consigneeBank: '', // 收款方账号开户银行
        consigneeOrgId: '', // 收款方组织id
        consigneeOrgName: '', // 收款方组织名称
        isPrepayment: '1', // 总部收到首付款，0-否，1-是
        payerAccount: '', // 付款方账号
        payerBank: '', // 付款方账号开户银行
        payerOrgId: '', // 付款方组织id
        payerOrgName: '', // 付款方组织名称
        totalAmount: '', // 支付金额
        buyerTradeRemark: '', // 摘要
        tradeTime: '', // 支付日期
        paymentClass: '1', // 交易方式
        tradeId: '', // 交易记录ID，编辑时必填
        type: '3', // 付款类型：1-乙方给甲方 2-甲方给总部 3-甲方给售后
      },

      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},

      actvieFlag: '',
      // 收款
      partAConsigneeFlag: 0,
      hqConsigneeFlag: 0,
      serviceConsigneeFlag: 0,
      // 付款
      partAPayerFlag: 0,
      hqPayerFlag: 0,
      servicePayerFlag: 0,
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

    // this.getPartyA();
    // 设置收款 付款方信息
    this.setContractInfo();
    // 设置总部收款方
    this.getFactoryInfo();
    // 获取首付款信息
    // this.getPayment();
    this.initDialog();
  },
  methods: {
    initDialog() {
      if (this.model.type === 'edit') {
        // 编辑
        // 付款类型：1-乙方给甲方 2-甲方给总部 3-甲方给售后
        if (this.model.data.type === '1') {
          // this.$setFormatData(this.partAReceive, this.model.data);
          this.partAReceive = Object.assign(this.partAReceive, this.model.data);
        } else if (this.model.data.type === '2') {
          // this.$setFormatData(this.hqReceive, this.model.data);
          this.hqReceive = Object.assign(this.hqReceive, this.model.data);
        } else {
          this.serviceReceive = Object.assign(this.serviceReceive, this.model.data);
        }
        this.form.paymentType = this.model.data.type;
      }
    },
    // getPayment() {
    //   this.$getJSON(apis.crmContractGetPrepayment, {
    //     bizId: this.contractId,
    //     bizClass: this.contractClass,
    //   }).then((res) => {
    //     // this.partAReceive = res.data.partAReceive;
    //     // this.serviceReceive = res.data.serviceReceive;

    //     // 首付款状态，0-未付，1-租赁方已付，2-代理公司垫付
    //     if (res.data.prepaymentState) {
    //       if (res.data.hqReceive) {
    //         this.hqReceive = Object.assign(this.hqReceive, res.data.hqReceive);
    //       }
    //       if (res.data.partAReceive) {
    //         this.partAReceive = Object.assign(this.partAReceive, res.data.partAReceive);
    //       }
    //       if (res.data.serviceReceive) {
    //         this.serviceReceive = Object.assign(this.serviceReceive, res.data.serviceReceive);
    //       }
    //       // console.log(this.hqReceive,this.partAReceive,this.partAReceive);
    //     } else {
    //       // 未付款
    //     }
    //   });
    // },
    // 图片校验
    checkImg(form, certificate) {
      if (form.attachList && form.attachList.length > 0) {
        form[certificate] = true;
      } else {
        form[certificate] = '';
      }
    },
    // 获取甲方信息（当前登录人所属组织）
    // getPartyA: function () {
    //   this.$getJSON(apis.partnerGetPartyA).then((res) => {
    //     // this.projectList = res.data;
    //     // this.$setFormatData(this.form.partnerInfo, res.data);
    //     this.partAReceive.consigneeOrgId = res.data.partnerOrgId; // 甲方授权代表
    //     // this. partAReceive.partyABizId = res.data.partnerId; // 甲方授权代表biBizId
    //     this.partAReceive.consigneeOrgName = res.data.partnerName;

    //     this.partAReceive.consigneeAccount = res.data.partyADepositNumber || ''; // 甲方授权代表银行卡号码
    //     this.partAReceive.consigneeBank = res.data.partyADepositBank || ''; // 甲方授权代表银行卡开户支行
    //     // this. partAReceive.partyADepositName = res.data.partyADepositName || ''; // 甲方授权代表银行卡开户名
    //   });
    // },
    // 添加银行卡
    addBankCard: function (partnerOrgId, flag) {
      this.dialogVisible = true;
      this.dialogModel.title = this.i18n.dialog_title_add_bank_card_information;
      this.dialogModel.partnerOrgId = partnerOrgId;
      this.actvieFlag = flag;
    },
    // 刷新银行卡
    refreshBankcardList: function () {
      this[this.actvieFlag] = this[this.actvieFlag] + 1;
    },
    // 设置付款方 收款方
    setContractInfo: function () {
      // 设置甲乙收款付款方信息 乙方是付款方 甲方是收款方
      // 甲方授权代表
      this.partAReceive.consigneeOrgId = this.contractInfo.partyAId; // 甲方授权代表
      this.partAReceive.consigneeOrgName = this.contractInfo.partyAName;
      this.partAReceive.consigneeAccount = this.contractInfo.partyADepositNumber; // 甲方授权代表银行卡号码
      this.partAReceive.consigneeBank = this.contractInfo.partyADepositBank; // 甲方授权代表银行卡开户支行
      // 乙方代表
      this.partAReceive.payerOrgId = this.contractInfo.customerId; // 付款方组织id
      this.partAReceive.payerOrgName = this.contractInfo.customerName; // 付款方组织名称

      // 设置甲方 总部  甲方是付款方 总部是收款方
      this.hqReceive.payerOrgId = this.contractInfo.partyAId; // 甲方授权代表
      this.hqReceive.payerOrgName = this.contractInfo.partyAName;
      this.hqReceive.payerAccount = this.contractInfo.partyADepositNumber; // 甲方授权代表银行卡号码
      this.hqReceive.payerBank = this.contractInfo.partyADepositBank; // 甲方授权代表银行卡开户支行

      // 设置甲方 售后 甲方是付款方 售后是收款方
      this.serviceReceive.payerOrgId = this.contractInfo.partyAId; // 甲方授权代表
      this.serviceReceive.payerOrgName = this.contractInfo.partyAName;
      this.serviceReceive.payerAccount = this.contractInfo.partyADepositNumber; // 甲方授权代表银行卡号码
      this.serviceReceive.payerBank = this.contractInfo.partyADepositBank; // 甲方授权代表银行卡开户支行

      this.serviceReceive.consigneeOrgId = this.contractInfo.afterServiceId; // 售后授权代表
      this.serviceReceive.consigneeOrgName = this.contractInfo.afterServiceName;

      // 乙方给甲方代表 首付款金额
      this.partAReceive.totalAmount = this.firstTotal;
      // 甲方给总部 押金总额+总部应收首期租金
      this.hqReceive.totalAmount = this.hqProfitTotal;
      // 甲方给售后 售后应收金额
      this.serviceReceive.totalAmount = this.serviceProfitTotal;
      // 甲方和售后一样
      if (this.contractInfo.partyAId === this.contractInfo.afterServiceId) {
        this.serviceReceive.isPrepayment = '0';
      }
      // console.log(this.partAReceive.totalAmount, this.hqReceive.totalAmount, this.serviceReceive.totalAmount);
    },
    // 获取收款方总部信息
    getFactoryInfo: function () {
      this.$getJSON(apis.crmPartnerGetFactory).then((res) => {
        this.hqReceive.consigneeOrgId = res.data.partnerOrgId; // 售后授权代表
        this.hqReceive.consigneeOrgName = res.data.partnerName;
      });
    },
    // 收款方 银行下拉
    onConsigneeDepositNumber: function (item, paymentForm) {
      paymentForm.consigneeBank = item.depositBank;
    },
    // 付款方
    onPayerDepositNumber: function (item, paymentForm) {
      paymentForm.payerBank = item.depositBank;
    },

    // 首付款信息
    savePayment: function () {
      this.$refs.partAReceive.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$refs.hqReceive.validate((valid1) => {
          if (!valid1) {
            return;
          }
          this.$refs.serviceReceive.validate((valid2) => {
            if (!valid2) {
              return;
            }
            this.form.operateFlag = this.operateFlag;
            this.form.bizId = this.contractId;
            this.form.bizClass = this.contractClass;
            this.form.partAReceive = this.partAReceive;
            this.form.hqReceive = this.hqReceive;
            this.form.serviceReceive = this.serviceReceive;

            this.$postJSON(apis.crmContractSavePrepayment, this.form).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: this.i18n.com_save_success,
                  type: 'success',
                });
                this.$emit('success', 5);
              }
            });
          });
        });
      });
    },
    // 确认保存
    confirm: function () {
      this.$refs.paymentForm.savePayment();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    savePaymentItem: function () {
      if (this.form.paymentType === '1') {
        // 乙方付款给甲方代表
        this.$refs.partAReceive.validate((valid) => {
          if (!valid) {
            return;
          }
          this.$emit('addItem', this.partAReceive);
          this.closeDialog();
        });
      } else if (this.form.paymentType === '2') {
        // 甲方代表付款给总部
        this.$refs.hqReceive.validate((valid) => {
          if (!valid) {
            return;
          }
          this.$emit('addItem', this.hqReceive);
          this.closeDialog();
        });
      } else {
        // 甲方代表付款给售后
        this.$refs.serviceReceive.validate((valid) => {
          if (!valid) {
            return;
          }
          this.$emit('addItem', this.serviceReceive);
          this.closeDialog();
        });
      }
    },
    // 保存新增
    saveSuccess: function () {
      this.visible = false;
      this.$emit('success');
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-payment-item {
  // padding: 24px;

  .payment-form {
    height: 100%;
    .el-form {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    // .form-label{

    // }
    .form-line {
      flex: 1;
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 100%;
      // margin-right: ;
      .form-item {
        // width: 440px;
        // margin 27px;
        // flex: 0 0 440px;
        // flex: 1;
        // margin-right: 16px;
        .payment-form-box {
          // width: 440px;
          border: 1px solid #f6f7fb;
          height: 100%;
          .header {
            background: #f6f7fb;

            height: 152px;
            padding: 20px;
            .header-to {
              span {
                height: 18px;
                font-size: 14px;
                font-weight: bold;
                color: #495057;
                line-height: 18px;
                margin-left: 10px;
              }
              .icon {
                font-size: 16px;
                line-height: 18px;
                color: #0d9ae0;
                display: inline-block;
              }
              .to {
                .icon {
                  color: #16d071;
                  margin: 5px 0;
                }
              }
            }
            .radio {
              margin-top: 35px;
            }
          }

          .line {
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
